import { Component, OnInit,Inject,NgZone,ElementRef,ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog} from '@angular/material/dialog';
import { FormControl,FormGroup,FormBuilder } from '@angular/forms';
import { DataService } from 'src/app/services/data.service';
import { NotifierService } from 'angular-notifier';
import { Validators } from '@angular/forms';
import { element } from 'protractor';

@Component({
  selector: 'app-confirm-listado-tabla-iniciativas',
  templateUrl: './confirm-listado-tabla-iniciativas.component.html',
  styleUrls: ['./confirm-listado-tabla-iniciativas.component.css']
})
export class ConfirmListadoTablaIniciativasComponent implements OnInit {
  confirmComentarios:boolean=false;
  name:string;
  email:string;
  id_iniciativa:number;
  tipoIniciativa:number;
  id_periodo:number;
  folioIniciativa:number;
  agregarComentario:boolean=false;
 
  //Modal equipo de trabajo
  confirmEquipoTrabajo:boolean=false;
  eliminarEquipoTrabajo:boolean=false;
  agregarEquipoTrabajo:boolean=false;
  etiqueta:string;

  nombreIntegrante:string;
  comentarioEliminacion:string;
  nombreEnlace:string;
  listaEquipo:any[]=[];
  listaEquipoData:any[]=[];
  listaEquipoConfirmacion:any[]=[]
  analista:any[]=[]
  lider:any[]=[]
  desarrollador:any[]=[]

  tablaComentarios:any[]=[];
  listaDestinatarios:any[]=[];
  tablaComentariosNoVistos:any[]=[];
  tablaComentariosHistorial:any[]=[];

  nombreAnalista:string;
  nombreLider:string;
  confirmHistorialIniciativa:boolean=false;
  tablaHistorial:any[]=[];
  

  confirmCambioEstatus:boolean=false;
  
  //Listas de motivos
  listaEstatusAll:any[]=[];
  listaEstatus:any[]=[];

  listaMotivosCancelacion:any[]=[];
  listaMotivosSuspencion:any[]=[];
  listaMotivosRechazo:any[]=[];

  programacion:boolean=false;
  cancelacion:boolean=false;
  suspencion:boolean=false;
  rechazo:boolean=false;

  selectedValueMotCancelacion: number;
  solicitudCancelacion:number;
  solicitudEnvio:number;
  mostrarSolicitudCancelacion:boolean=false;
  solicitudCancelacionAutorizar:boolean=false;
  solicitudCancelacionRechazar:boolean=false;
  solicitudEnvioRechazar:boolean=false;

  mostrarSolicitudEnvio:boolean=false;
  justificacionSolicitud:string;

  archivo:File;
  @ViewChild('labelComentarios',{static:false})
  labelComentarios: ElementRef;
  nombreArchivo:string;
  id_comentario:number;

  nombreRol:string;
  rol:number;
  rolesCatalogo: { id_rol: number; nombre_rol: string; }[];

  //Array para guardar los destinatarios de comentarios
  jsonDestinatarios: { id_rol: number; email_usuarioDestinatario: string; }[]=[];

  observacionEstatus:string;
  idEstatus:number=0;
  rolSeleccionado:number=0;
  sinComentarios:boolean=false;
  usuarioVip:boolean=false;

  
  //Form de comentarios
  formComentarios: FormGroup = new FormGroup({});
  //Varibles para asignar los comentarios 
  integrante = new FormControl();
  comentario = new FormControl();

  url:FormControl;
  form: FormGroup = new FormGroup({});
  nombreArchivoSolicitud:string;
  contentFile:string;
  
  constructor( @Inject(MAT_DIALOG_DATA) 
  public data: string,

  private dataService: DataService,
  private notifier: NotifierService, private fb: FormBuilder,private fc: FormBuilder) { 

    const reg = '(https?://)?([\\da-z./-]+)\\.([a-z.]{2,6})[/-\\w .-=#&%!?@$:;]*/?';
    this.form = fb.group({
      url: ['', [Validators.required, Validators.pattern(reg)]]
    })

    //Form comentarios
    this.formComentarios=fc.group({
      integrante: ['', [Validators.required]],
      comentario: ['', [Validators.required]]
    })
  }

  get f(){
    return this.form.controls;
  }

 
   

  ngOnInit(): void {
    if(this.data['opcion']==10)
    { this.rolesCatalogoMe();  
      this.confirmComentarios=true;
      this.name=this.data['userName'];
      this.email=this.data['email'];
      this.id_iniciativa=this.data['id_iniciativa'];
      this.rol=this.data['idRol'];
      this.usuarioVip=this.data['usuarioVip'];
      this.getEquipoTrabajoComentario();    
      //verificamos si ya hay comentarios
      this.getComentariosIniciativa(this.id_iniciativa,this.email, this.rol);
      this.folioIniciativa=this.data['folio'];
      this.data="";
    }
    
    //Modal de consulta de integrantes de equipo
    if(this.data['opcion']==1)
    {
      this.confirmEquipoTrabajo=true;
      this.name=this.data['userName'];
      this.email=this.data['email'];
      this.id_iniciativa=this.data['id_iniciativa'];
      this.folioIniciativa=this.data['folio'];
      this.getEquipoTrabajo();
      this.data="";
    }
    
    //Abrir modal de confirmación de eliminacion de integrante
    if(this.data['opcion']==2)
    {this.eliminarEquipoTrabajo=true;
      this.nombreIntegrante=this.data['nombreIntegrante'];
      this.data="";
    }

    //Modal de historial
    if(this.data['opcion']==3)
    {this.confirmHistorialIniciativa=true;
      this.folioIniciativa=this.data['folio'];
      this.getHistorialIniciativa(this.data['id_iniciativa']);
    }

    //Modal de cambio de estatus/mostrar solicitud
    if(this.data['opcion']==4)
    {
      this.folioIniciativa=this.data['folio'];
      this.id_iniciativa=this.data['id_iniciativa'];
      this.email=this.data['email'];
      this.rolSeleccionado=parseInt(this.data['rol']);
      this.solicitudCancelacion=this.data['solicitudCancelacion'];
      this.tipoIniciativa=this.data['tipoIniciativa'];
      //Si tiene solicitud de cancelación
      if(this.solicitudCancelacion)
      {
        this.mostrarSolicitudCancelacion=true;
        //Mostramos los detalles
        this.getSolicitudCancelacion(this.solicitudCancelacion);
      }
      else{
        this.confirmCambioEstatus=true;
        this.listCambioEstatus();
      }
    }

    
    //Modal de autorizacion solicitud cancelacion
    if(this.data['opcion']==5)
    {
      this.folioIniciativa=this.data['folio'];
      this.id_iniciativa=this.data['id_iniciativa'];
      this.email=this.data['email'];
      this.rolSeleccionado=parseInt(this.data['rol']);
      this.solicitudCancelacion=this.data['solicitudCancelacion'];
      this.solicitudCancelacionAutorizar=true;
      this.listMotivosCancelacion();
    }

    //Modal de rechazo de solicitud cancelacion
    if(this.data['opcion']==6)
    {
      this.folioIniciativa=this.data['folio'];
      this.id_iniciativa=this.data['id_iniciativa'];
      this.email=this.data['email'];
      this.rolSeleccionado=parseInt(this.data['rol']);
      this.solicitudCancelacion=this.data['solicitudCancelacion'];
      this.solicitudCancelacionRechazar=true;
      this.listMotivosCancelacion();
    }

    
    //Modal de solicitud de envio
    if(this.data['opcion']==7)
    {
      this.folioIniciativa=this.data['folio'];
      this.id_iniciativa=this.data['id_iniciativa'];
      this.email=this.data['email'];
      this.rolSeleccionado=parseInt(this.data['rol']);
      this.solicitudEnvio=this.data['solicitudEnvio'];
      //Si tiene solicitud de cancelación
      if(this.solicitudEnvio)
      {
        this.mostrarSolicitudEnvio=true;
        //Mostramos los detalles
        this.getSolicitudCancelacion(this.solicitudEnvio);
      }
      
    }

    
    //Modal de rechazo de solicitud envio
    if(this.data['opcion']==8)
    {
      this.folioIniciativa=this.data['folio'];
      this.id_iniciativa=this.data['id_iniciativa'];
      this.email=this.data['email'];
      this.rolSeleccionado=parseInt(this.data['rol']);
      this.solicitudEnvio=this.data['solicitudEnvio'];
      this.solicitudEnvioRechazar=true;
    }

    //Abrir modal de confirmación agregar integrante
    if(this.data['opcion']==9)
    {
      this.agregarEquipoTrabajo=true;
      this.id_iniciativa=this.data['id_iniciativa'];
      this.rolSeleccionado=this.data['rolLogin'];
      this.getEquipoTrabajoConfirmacion();
      this.data="";
    }
    
  }

  

  //Metodo para agregar periodo de envio
  addComentario(){
    this.agregarComentario=true;
  }
  
  //Método para guardar los comentarios
  guardarComentario()
  {
    var myJsonString="";
    if(this.formComentarios.controls['integrante']['value'])
    {
      for (let num of this.formComentarios.controls['integrante']['value'])
      {
        let email=num['email_usuario'];
        let rol=num['id_rol'];
        let valores=
        {
          'email_usuarioDestinatario':email,
          'id_rol':rol
        }
        this.jsonDestinatarios.push(valores);
      }
       myJsonString = JSON.stringify(this.jsonDestinatarios);
    }
    
    let datos={
      'id_iniciativa':this.id_iniciativa,
      'descripcion_comentario': this.formComentarios.controls['comentario'].value,
      'email_usuarioComentario':this.email,
      'jsonDestinatarios':myJsonString,
      'id_rol':this.rol,
      'nombre_archivoComentario': this.nombreArchivo
    }    
   this.dataService.agregarComentarios(datos).subscribe(
      data => {
        if (data['objData']) 
        {
          this.id_comentario=data['objData']['id_comentario'];
          if(this.nombreArchivo)
          {
            //Subimos el archivo
            this.dataService.subirArchivoComentarios(this.archivo,this.id_iniciativa,this.id_comentario).subscribe(
              data => {
                if (data['objData']) 
                {
                  this.notifier.notify(
                    'success',
                    'Comentario enviado correctamente.'
                  );}
              },
              error => {
                this.notifier.notify(
                  'error',
                  'Ha ocurrido un error al intentar enviar su comentario. Verifique su conexión de red o contacte al administrador.'
                );
              }
            )}
          else{
            this.notifier.notify(
              'success',
              'Comentario enviado correctamente.'
            );
          }
        }
      },
      error => {
        this.notifier.notify(
          'error',
          'Ha ocurrido un error al intentar enviar su comentario. Verifique su conexión de red o contacte al administrador.'
        );
      }
    );
  }

  //Comentarios de iniciativa
  getComentariosIniciativa(id:number, email:string,rol:number)
  {
    this.dataService.comentariosIniciativa(id, email,rol).subscribe(
      data => {
        if (data['data']) 
        {
          this.tablaComentarios=data['data'];
          //Si no hay comentarios
          if(this.tablaComentarios.length==0)
          {
            this.sinComentarios=true;
          }
          //Si hay comentarios
          else{
              for(let i of this.tablaComentarios)
              {
                //vistos
                if(i['estatus_comentarioVisto']==false)
                {
                  this.tablaComentariosNoVistos.push(i);
                }//no vistos
                else{
                  this.tablaComentariosHistorial.push(i);
                }

              }

          }
        }
        else{
        }
      },
      error => {
        console.error(error);
        this.notifier.notify(
          'error',
          'Ha ocurrido un error al intentar cargar los comentarios de la iniciativa. Contacta al administrador.'
        );
      }
    );
  }

  //Método para obtener los datos de la solicitud de cancelacion
  getSolicitudCancelacion(id:number)
  {
    this.dataService.getSolicitudCancelacion(id).subscribe(
      data => {
        if (data['objData']) 
        {

          //Verificamos si tiene archivo
          this.dataService.descargarArchivoSolicitudEnvio(this.id_iniciativa).subscribe(
            data => {
              if (data['objData']) 
              {
               
                this.nombreArchivoSolicitud=data['objData']['nombreArchivo'];
                this.contentFile=data['objData']['contenido'];
              }
              else{
                this.notifier.notify('error',data['errorMessage']);
              }
            },
            error => {
              console.error(error);
              this.notifier.notify(
                'error',
                'Ha ocurrido un error al intentar descargar su archivo. Verifique su conexión de red o contacte al administrador.'
              );
            }
          );
          this.justificacionSolicitud=data['objData']['justificacion_solicitudIniciativa'];
        }
        else{
           
        }
      },
      error => {
        console.error(error);
        this.notifier.notify(
          'error',
          'Ha ocurrido un error al intentar cargar la información de la solicitud. Contacta al administrador.'
        );
      }
    );

  }

  //Metodo para guardar la autorizacion de cancelacion
  guardarAutorizacionCancelacion()
  {
    
    let valores={
      'id_iniciativa':this.id_iniciativa,
      'id_solicitudIniciativa' : this.solicitudCancelacion,
      'respuesta_solicitudIniciativa':this.observacionEstatus,
      'id_motivo':this.selectedValueMotCancelacion,
      'userlogin':this.email,
      'id_rol':this.rolSeleccionado
    }
    this.dataService.autorizacionSolicitudCancelacion(valores).subscribe(
      data => {
        if (data['objData']) 
        {
          this.notifier.notify(
            'success',
            'Solicitud autorizada correctamente.'
          );
        }
        else{
          this.notifier.notify('error',data['errorMessage']);
        }
      },
      error => {
        console.error(error);
        this.notifier.notify(
          'error',
          'Ha ocurrido un error al intentar autorizar la solicitud. Verifique su conexión de red o contacte al administrador.'
        );
      }
    );

  }

  guardarRechazoCancelacion()
  {
    let valores={
      'id_iniciativa':this.id_iniciativa,
      'id_solicitudIniciativa' : this.solicitudCancelacion,
      'respuesta_solicitudIniciativa':this.observacionEstatus,
      'userlogin':this.email,
      'id_rol':this.rolSeleccionado
    }
    this.dataService.rechazoSolicitudCancelacion(valores).subscribe(
      data => {
        if (data['objData']) 
        {
          this.notifier.notify(
            'success',
            'Solicitud rechazada correctamente.'
          );
        }
        else{
          this.notifier.notify('error',data['errorMessage']);
        }
      },
      error => {
        this.notifier.notify(
          'error',
          'Ha ocurrido un error al intentar rechazar la solicitud. Verifique su conexión de red o contacte al administrador.'
        );
      }
    );

  }

  //Método para guardar la autorizacion de solicitud de envio
  guardarAutorizarEnvio(){
    
    let valores={
      'id_iniciativa':this.id_iniciativa,
      'id_solicitudIniciativa' : this.solicitudEnvio,
      'userlogin':this.email,
      'id_rol':this.rolSeleccionado

    }
    this.dataService.autorizacionSolicitudEnvio(valores).subscribe(
      data => {
        if (data['objData']) 
        {
          this.notifier.notify(
            'success',
            'Solicitud autorizada correctamente.'
          );
        }
        else{
          this.notifier.notify('error',data['errorMessage']);
        }
      },
      error => {
        console.error(error);
        this.notifier.notify(
          'error',
          'Ha ocurrido un error al intentar autorizar la solicitud. Verifique su conexión de red o contacte al administrador.'
        );
      }
    );

  }

  //Metodo para guardar el rechazo de solicitud de envio
  guardarRechazoEnvio()
  {
    let valores={
      'id_iniciativa':this.id_iniciativa,
      'id_solicitudIniciativa' : this.solicitudEnvio,
      'respuesta_solicitudIniciativa':this.observacionEstatus,
      'userlogin':this.email,
      'id_rol':this.rolSeleccionado
    }
    this.dataService.rechazoSolicitudEnvio(valores).subscribe(
      data => {
        if (data['objData']) 
        {
          this.notifier.notify(
            'success',
            'Solicitud rechazada correctamente.'
          );
        }
        else{
          this.notifier.notify('error',data['errorMessage']);
        }
      },
      error => {
        this.notifier.notify(
          'error',
          'Ha ocurrido un error al intentar rechazar la solicitud. Verifique su conexión de red o contacte al administrador.'
        );
      }
    );

  }

  listCambioEstatus()
  {
    
    this.dataService.getListCambioEstatus().subscribe(
      data => {
        if (data['data']) 
        {
          this.listaEstatusAll=data['data'];   
          this.filtrarEstatusRol(this.rolSeleccionado);
        }
        else{
           
        }
      },
      error => {
        console.error(error);
        this.notifier.notify(
          'error',
          'Ha ocurrido un error al intentar cargar los estatus de cambio. Contacta al administrador.'
        );
      }
    );

  }


  filtrarEstatusRol(rol:number)
  {
    //Eliminamos los valores segun el rol
    switch (rol) 
    {
      //Gestor de analisis y diseño
      case 3:
        this.listaEstatusAll.forEach((element,index) => 
        {
          //Nuevo sistema
          if(this.tipoIniciativa===1)
          {
            if(
              element['id_estatusIniciativa']==3 || 
              element['id_estatusIniciativa']==4 || 
              element['id_estatusIniciativa']==5 ||
              element['id_estatusIniciativa']==11 ||
              element['id_estatusIniciativa']==12 ||
              element['id_estatusIniciativa']==13 ||
              element['id_estatusIniciativa']==15 ||
              element['id_estatusIniciativa']==16 
            )
            {
              this.listaEstatus.push(element);
            }
          }
          //Cambio 
          else{
            if(
              element['id_estatusIniciativa']==4 || 
              element['id_estatusIniciativa']==5 ||
              element['id_estatusIniciativa']==11 ||
              element['id_estatusIniciativa']==12 ||
              element['id_estatusIniciativa']==13 ||
              element['id_estatusIniciativa']==15 ||
              element['id_estatusIniciativa']==16
              ) 
            {
               this.listaEstatus.push(element);
            }

          }
          
        });
        break;
        //Analista de TI
      case 4:
        this.listaEstatusAll.forEach((element,index) => 
        {

              //Nuevos sistemas
              if(this.tipoIniciativa===1)
              {
                if(
                element['id_estatusIniciativa']==3 || 
                element['id_estatusIniciativa']==4 || 
                element['id_estatusIniciativa']==5 ||
                element['id_estatusIniciativa']==11 ||
                element['id_estatusIniciativa']==12 ||
                element['id_estatusIniciativa']==13 ||
                element['id_estatusIniciativa']==15 ||
                element['id_estatusIniciativa']==16
                )  
              {
                 this.listaEstatus.push(element);
              }

              }
              //Cambios proyectos
              else{
                if(
                element['id_estatusIniciativa']==4 || 
                element['id_estatusIniciativa']==5 ||
                element['id_estatusIniciativa']==11 ||
                element['id_estatusIniciativa']==12 ||
                element['id_estatusIniciativa']==13 ||
                element['id_estatusIniciativa']==15 ||
                element['id_estatusIniciativa']==16
              )  
              {
                 this.listaEstatus.push(element);
              }

              }         
        });
        break;
        //Gestor de cambios
        case 5:
        this.listaEstatusAll.forEach((element,index) => 
        {
          if(element['id_estatusIniciativa']==5 ||
            element['id_estatusIniciativa']==11 ||
            element['id_estatusIniciativa']==12 ||
            element['id_estatusIniciativa']==13 ||
            element['id_estatusIniciativa']==16
          )
          {
             this.listaEstatus.push(element);
          }
        });
        break;
        //Lider SAP
        case 6:
        this.listaEstatusAll.forEach((element,index) => 
        {
          //Nuevo sistema
          if(this.tipoIniciativa===1)
          {
            if(element['id_estatusIniciativa']==3 || 
            element['id_estatusIniciativa']==7  ||
            element['id_estatusIniciativa']==8  ||
            element['id_estatusIniciativa']==9  ||
            element['id_estatusIniciativa']==10 ||
            element['id_estatusIniciativa']==16 )
            {
              this.listaEstatus.push(element);
           }
          }
          //Cambios
          else{
            if(
            element['id_estatusIniciativa']==7  ||
            element['id_estatusIniciativa']==8  ||
            element['id_estatusIniciativa']==9  ||
            element['id_estatusIniciativa']==10 ||
            element['id_estatusIniciativa']==16  )
          {
             this.listaEstatus.push(element);
          }
          }
        });
        break;
        //Lider no SAP
        case 7:
        this.listaEstatusAll.forEach((element,index) => 
        {
          //Nuevo sistema
          if(this.tipoIniciativa===1)
          {
            if(
              element['id_estatusIniciativa']==3  || 
              element['id_estatusIniciativa']==7  ||
              element['id_estatusIniciativa']==8  ||
              element['id_estatusIniciativa']==9  ||
              element['id_estatusIniciativa']==10 ||
              element['id_estatusIniciativa']==16 )

            {
               this.listaEstatus.push(element);
            }

          }
          //Cambio
          else{
            if(
              element['id_estatusIniciativa']==7  ||
              element['id_estatusIniciativa']==8  ||
              element['id_estatusIniciativa']==9  ||
              element['id_estatusIniciativa']==10 ||
              element['id_estatusIniciativa']==16 )
            {
               this.listaEstatus.push(element);
            }
          }
        });
        break;
      case 13:
        this.listMotivosCancelacion();
        break;
    }

  }


  
  listMotivosCancelacion()
  {
    
    this.dataService.getListMotivosCancelacion().subscribe(
      data => {
        if (data['data']) 
        {
          this.listaMotivosCancelacion=data['data'];      
        }
        else{
           
        }
      },
      error => {
        console.error(error);
        this.notifier.notify(
          'error',
          'Ha ocurrido un error al intentar cargar los motivos de cancelacion. Contacta al administrador.'
        );
      }
    );
  }

  
  listMotivosSuspencion()
  {
    
    this.dataService.getListMotivosSuspencion().subscribe(
      data => {
        if (data['data']) 
        {
          this.listaMotivosSuspencion=data['data'];      
        }
        else{
           
        }
      },
      error => {
        console.error(error);
        this.notifier.notify(
          'error',
          'Ha ocurrido un error al intentar cargar los motivos de suspención. Contacta al administrador.'
        );
      }
    );
  }


  
  listMotivosRechazo()
  {
    
    this.dataService.getListMotivosRechazo().subscribe(
      data => {
        if (data['data']) 
        {
          this.listaMotivosRechazo=data['data'];      
        }
        else{
           
        }
      },
      error => {
        console.error(error);
        this.notifier.notify(
          'error',
          'Ha ocurrido un error al intentar cargar los motivos de rechazo. Contacta al administrador.'
        );
      }
    );
  }


  cambioEstatus(id_estatus:number)
  {
    this.selectedValueMotCancelacion=0;
    this.idEstatus=id_estatus;
    this.observacionEstatus="";

    switch (id_estatus) 
    {
      case 11:
        this.listMotivosRechazo();
        break;
      case 12:
        this.listMotivosSuspencion();
        break;
      case 13:
        this.listMotivosCancelacion();
        break;
    }


  }


  
  //Método para cambiar el estatus
  guardarCambioEstatusProgramacion(form:any)
  {
    let valores={
      'id_iniciativa':this.id_iniciativa,
      'email_usuario':this.email,
      'observacion':form.controls['url'].value,
      'id_estatus':this.idEstatus,
      'id_motivo':this.selectedValueMotCancelacion,
      'id_rol':this.rolSeleccionado
    }

    this.dataService.guardarCambioEstatus(valores).subscribe(
      data => {
        if (data['objData']) 
        {
          this.notifier.notify(
            'success',
            'Se cambio el estatus correctamente.'
          );
        }
        else{
          this.notifier.notify('error',data['errorMessage']);
        }
      },
      error => {
        console.error(error);
        this.notifier.notify(
          'error',
          'Ha ocurrido un error al intentar cambiar el estatus. Verifique su conexión de red o contacte al administrador.'
        );
      }
    );
    
  }

  //Método para cambiar el estatus
  guardarCambioEstatus() {
    let valores = {
      'id_iniciativa': this.id_iniciativa,
      'email_usuario': this.email,
      'observacion': this.observacionEstatus,
      'id_estatus': this.idEstatus,
      'id_motivo': this.selectedValueMotCancelacion,
      'id_rol': this.rolSeleccionado
    };
  
    this.dataService.guardarCambioEstatus(valores).subscribe(
      data => {
        console.log('Respuesta del servidor:', data);  // Agrega este log
        if (data['objData']) {
          this.notifier.notify('success', 'Se cambio el estatus correctamente.');
        } else {
          this.notifier.notify('error', data['errorMessage']);
        }
      },
      error => {
        console.error(error);
        this.notifier.notify(
          'error',
          'Ha ocurrido un error al intentar cambiar el estatus. Verifique su conexión de red o contacte al administrador.'
        );
      }
    );
  }
  

  //Método para cargar la lista de miembros de equipo
  getEquipoTrabajo()
  {
    this.dataService.getEquipoTrabajo(this.id_iniciativa).subscribe(data => {
      this.listaEquipoData = data['data'];
      this.listaEquipoData.forEach(element => {
        if(element['estatus_equipoTrabajo']==true && element['confirmacion_equipoTrabajo']==true)
        {
          this.listaEquipo.push(element);

        }
        
      }); 
      
    });

  }


  
  //Método para cargar la lista de miembros de equipo para comentarios
  getEquipoTrabajoComentario()
  {
    this.dataService.getEquipoTrabajo(this.id_iniciativa).subscribe(data => {
      this.listaEquipoData = data['data'];
      this.listaEquipoData.forEach(element => {
        if(element['estatus_equipoTrabajo']==true && element['confirmacion_equipoTrabajo']==true)
        {
          if(element['id_rol']==this.rol && element['email_usuario']==this.email)
          {
              //no se agrega a la lista
          }
          else{
            this.listaEquipo.push(element);
          }
        }
        
      }); 
      
    });

  }


  //Método para cargar la lista de miembros de equipo para confirmacion
  getEquipoTrabajoConfirmacion()
  {
    this.dataService.getEquipoTrabajo(this.id_iniciativa).subscribe(data => {
      this.listaEquipo = data['data'];
      //Validamos el rol del login
      switch (this.rolSeleccionado.toString()) 
      {
        //Gestor de cambios
        case '5':
          this.listaEquipo.forEach((element,index )=> {

            if(element['id_rol']==6 || element['id_rol']==7 )
            {
              this.listaEquipoConfirmacion.push(element);
            }
            if(element['id_rol']==8)
            {
              this.listaEquipoConfirmacion.push(element);
            }
          });
          break;
          //Analista de TI
        case '4':
          this.listaEquipo.forEach((element,index )=> {
            if(element['id_rol']==5)
            {
              this.listaEquipoConfirmacion.push(element);
            }
          });
          break;
          //Gestor de analisis y diseño
        case '3':
          this.listaEquipo.forEach((element,index )=> {
            if(element['id_rol']==4)
            {
              this.listaEquipoConfirmacion.push(element);
            }
            if(element['id_rol']==5)
            {
              this.listaEquipoConfirmacion.push(element);
            }
          });
        break;
        //Jefe de area DIDS
        case '12':
          this.listaEquipo.forEach((element,index )=> {
            if(element['id_rol']==6 || element['id_rol']==7 )
            {
              this.listaEquipoConfirmacion.push(element);
            }
            if(element['id_rol']==8)
            {
              this.listaEquipoConfirmacion.push(element);
            }
          });
        break;
        default:
          break;
      }


      
     /* this.listaEquipo.forEach((element,index )=> {
        if(element['id_rol']==1 || element['id_rol']==2)
        {
          this.nombreEnlace=element['nombre_usuario'];
        }
        if(element['id_rol']==4)
        {
          this.nombreAnalista=element.nombre_usuario;
          //this.analista.push(element);

        }
        if(element['id_rol']==6 || element['id_rol']==7 )
        {
          this.nombreLider=element.nombre_usuario;
          //this.lider.push(element);
        }
        if(element['id_rol']==8)
        {
          this.desarrollador.push(element);
        }
      });*/
      
    });

  }

  
  //Metodo para obtener el historial de la iniciativa
  getHistorialIniciativa(id:number)
  {
    this.dataService.historialIniciativa(id).subscribe(
      data => {
        if (data['data']) 
        {
          this.tablaHistorial=data['data'];  
        }
        else{
        }
      },
      error => {
        this.notifier.notify(
          'error',
          'Ha ocurrido un error al intentar cargar el historial de la iniciativa. Contacta al administrador.'
        );
      }
    );

  }

  //Método para cargar los roles activos de BD
  rolesCatalogoMe()
  {
    this.dataService.obtenerTiposUsuariosv2().subscribe(
      data => {
        this.rolesCatalogo = data['data'];
        this.nombreRoles(this.rol);
      },
      error => {
        console.error(error);       
      }
    );
  }

  //Metodo para obtener el nombre del rol
  nombreRoles(rol) 
 {
   if (this.rolesCatalogo.indexOf(rol) === -1) 
   {
     for (var i in this.rolesCatalogo) 
     {
       if(this.rolesCatalogo[i].id_rol==rol)
       {
         this.nombreRol=this.rolesCatalogo[i]['nombre_rol'];
       }
       
     }
   } else if (this.rolesCatalogo.indexOf(rol) > -1) {  
   }
}



onFileChange(event: any) 
{
  if (event.target.files && event.target.files.length) {
    const [file] = event.target.files;
    this.archivo=file;
    this.labelComentarios.nativeElement.innerText = file.name;
    this.nombreArchivo=file.name;
  }
}


/*private convertBase64ToBlob() {
  const typeDoc = this.nombreArchivoSolicitud.split('.')[1];
  const decodedData = encodeURIComponent (this.contentFile);
  let newBlob = new Blob([decodedData], { type: typeDoc });
    // IE no permite objetos blob directamente en el atributo href de un link
    // en su lugar hay que usar msSaveOrOpenBlob
    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
      window.navigator.msSaveOrOpenBlob(newBlob);
      return;
    }
    const data = window.URL.createObjectURL(newBlob);
     let link = document.createElement('a');
    link.href = data;
    link.download = this.nombreArchivoSolicitud;
    // Esta linea es necesaria desde que link.click() ya no funciona en las ultimas versiones de firefox
    link.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));

    setTimeout(function () {
      // Para Firefox es necesario retrasar la revocacion del objeto ObjectURL
      window.URL.revokeObjectURL(data);
      link.remove();
    }, 100);
}*/

convertBase64ToBlob()
{
  if(window.navigator && window.navigator.msSaveOrOpenBlob){ 
    // download PDF in IE
    let byteChar = atob(this.contentFile);
    let byteArray = new Array(byteChar.length);
    for(let i = 0; i < byteChar.length; i++){
      byteArray[i] = byteChar.charCodeAt(i);
    }
    let uIntArray = new Uint8Array(byteArray);
    let blob = new Blob([uIntArray], {type : 'application/pdf'});
    window.navigator.msSaveOrOpenBlob(blob, `${this.nombreArchivoSolicitud}.pdf`);
  } else {
    // Download PDF in Chrome etc.
    const source = `data:application/pdf;base64,${this.contentFile}`;
    const link = document.createElement("a");
    link.href = source;
    link.download = `${this.nombreArchivoSolicitud}`
    link.click();
  }
  
}





descargarArchivo(archivo:string,id_comentario:number)
{
  this.dataService.descargarArchivoComentarios(this.id_iniciativa,archivo,id_comentario).subscribe(res => {
    // Este es necesario para crear un objeto blob con el tipo de archivo
    // puesto explicitamente, de lo contrario solo Chrome funcionara correctamente
    let newBlob = new Blob([res], { type: this.obtenerTipoArchivo(archivo) });
    // IE no permite objetos blob directamente en el atributo href de un link
    // en su lugar hay que usar msSaveOrOpenBlob
    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
      window.navigator.msSaveOrOpenBlob(newBlob);
      return;
    }
    const data = window.URL.createObjectURL(newBlob);
     let link = document.createElement('a');
    link.href = data;
    link.download = archivo;
    // Esta linea es necesaria desde que link.click() ya no funciona en las ultimas versiones de firefox
    link.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));

    setTimeout(function () {
      // Para Firefox es necesario retrasar la revocacion del objeto ObjectURL
      window.URL.revokeObjectURL(data);
      link.remove();
    }, 100);

  });

}

private obtenerTipoArchivo(archivo: string): string {
  let tipoArchivo: string;
  let extencion: string = archivo.split('.').pop();

  switch (extencion) {
    case 'pdf':
      tipoArchivo = 'application/pdf';
      break;
    case 'xls':
      tipoArchivo = 'application/vnd.ms-excel';
      break;
    case 'xlsx':
      tipoArchivo = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
      break;
    case 'csv':
      tipoArchivo = 'application/csv';
      break;
    case 'zip':
      tipoArchivo = 'application/zip';
      break;
    case 'rar':
      tipoArchivo = 'application/x-rar-compressed';
      break;

    default:
      tipoArchivo = 'text/plain';
      break;
  }
  return tipoArchivo;
}


}
